"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _SiteInfo = _interopRequireDefault(require("./SiteInfo"));
var _hooks = require("../../hooks");
var _constants = require("../../utils/constants");
var _reducers = require("../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _CheckAccessToSite = require("../CheckAccessToSite");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SiteInfoContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    onForbidden
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_CheckAccessToSite.CheckAccessToSite, {
    showIf: true,
    onForbidden: onForbidden
  }, /*#__PURE__*/_react.default.createElement(_SiteInfo.default, null));
});
const SiteInfoConnect = /*#__PURE__*/(0, _react.memo)(_ref2 => {
  let {
    onForbidden
  } = _ref2;
  (0, _hooks.useConnectSite)();
  return /*#__PURE__*/_react.default.createElement(SiteInfoContent, {
    onForbidden: onForbidden
  });
});
const SiteInfoInject = props => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      sites: _reducers.sites,
      map: _reducers.map
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(SiteInfoConnect, props);
};
exports.SiteInfo = SiteInfoInject;